import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import CheckIcon from '@material-ui/icons/Check';
import UndoIcon from '@material-ui/icons/Undo';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import FilterListIcon from '@material-ui/icons/FilterList';
import AddIcon from '@material-ui/icons/Add';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import InputAdornment from '@material-ui/core/InputAdornment';
import DashboardIcon from '@material-ui/icons/Dashboard';
import RepeatIcon from '@material-ui/icons/Repeat';
import StopIcon from '@material-ui/icons/Stop';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import TableChartIcon from '@material-ui/icons/TableChart';
import Tooltip from '@material-ui/core/Tooltip';
// Novos imports para funcionalidades completas
import CommentIcon from '@material-ui/icons/Comment';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import WarningIcon from '@material-ui/icons/Warning';
import TodayIcon from '@material-ui/icons/Today';
import EventIcon from '@material-ui/icons/Event';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import CircularProgress from '@material-ui/core/CircularProgress';
// Icons para visibilidade de tarefas
import LockIcon from '@material-ui/icons/Lock';
import PublicIcon from '@material-ui/icons/Public';
import { format, isToday, isTomorrow, parseISO, isPast } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import { AuthContext } from '../../context/Auth/AuthContext';
import taskService from '../../services/taskService';
import taskRecurrenceService from '../../services/taskRecurrence';
import taskReorderService from '../../services/taskReorder';
import TaskFormModal from '../../components/TaskFormModal';
import RecurrenceDeleteModal from '../../components/RecurrenceDeleteModal';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { socketConnection } from '../../services/socket';

// Função utilitária para mapear categorias com ícones e labels
const getCategoryLabel = (category) => {
  const categoryMap = {
    // 🏢 Departamentais
    'administrativo': '🏢 Administrativo',
    'financeiro': '💰 Financeiro',
    'comercial': '🤝 Comercial',
    'marketing': '📢 Marketing',
    'atendimento': '📞 Atendimento',
    'recursos-humanos': '👥 Recursos Humanos',
    'tecnologia': '💻 Tecnologia',
    'juridico': '⚖️ Jurídico',
    
    // 📋 Atividades
    'reuniao': '🤝 Reunião',
    'projeto': '📋 Projeto',
    'treinamento': '🎓 Treinamento',
    'apresentacao': '📊 Apresentação',
    'documentacao': '📄 Documentação',
    'analise': '🔍 Análise',
    'planejamento': '📅 Planejamento',
    'revisao': '✅ Revisão',
    
    // 🎯 Especiais
    'urgente': '🚨 Urgente',
    'follow-up': '🔄 Follow-up',
    'pessoal': '👤 Pessoal',
    'manutencao': '🔧 Manutenção',
    'auditoria': '🔎 Auditoria',
    'compliance': '📜 Compliance'
  };
  
  return categoryMap[category] || category; // Mantém compatibilidade com categorias antigas
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '1rem',
    padding: '1rem',
    [theme.breakpoints.down('sm')]: {
      margin: '0.5rem',
      padding: '0.5rem'
    }
  },
  formContainer: {
    width: '100%',
    maxWidth: '800px',
    marginBottom: '2rem',
    padding: '1.5rem',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '8px',
    boxShadow: theme.shadows[2]
  },
  filterContainer: {
    width: '100%',
    maxWidth: '800px',
    marginBottom: '1rem',
    padding: '1rem',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '8px',
    boxShadow: theme.shadows[1]
  },
  filterRow: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
    marginBottom: '1rem',
    flexWrap: 'wrap'
  },
  searchField: {
    flexGrow: 1,
    minWidth: '200px'
  },
  filterField: {
    minWidth: '120px'
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginBottom: '1rem'
  },
  inputRow: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center'
  },
  input: {
    flexGrow: 1
  },
  formControl: {
    minWidth: 120
  },
  listContainer: {
    width: '100%',
    maxWidth: '800px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '8px',
    boxShadow: theme.shadows[2]
  },
  taskItem: {
    marginBottom: '8px',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  selectedTask: {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.action.selected
  },
  bulkActionsBar: {
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    zIndex: 5
  },
  bulkActionsGroup: {
    display: 'flex',
    gap: theme.spacing(1)
  },
  completedTask: {
    opacity: 0.6,
    textDecoration: 'line-through'
  },
  archivedTask: {
    opacity: 0.7,
    backgroundColor: theme.palette.grey[100],
    borderLeft: `4px solid #795548`
  },
  priorityChip: {
    marginRight: '8px',
    color: '#FFFFFF',
    '& .MuiChip-label': {
      color: '#FFFFFF'
    }
  },
  categoryChip: {
    marginRight: '8px',
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.contrastText
  },
  statusChip: {
    marginRight: '8px',
    color: '#FFFFFF',
    '& .MuiChip-label': {
      color: '#FFFFFF'
    }
  },
  activeFiltersContainer: {
    display: 'flex',
    gap: '0.5rem',
    flexWrap: 'wrap',
    marginTop: '0.5rem'
  },
  dragHandle: {
    cursor: 'grab',
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.primary.main
    }
  },
  dragging: {
    boxShadow: theme.shadows[8],
    transform: 'rotate(5deg)',
    opacity: 0.9
  },
  // Novos estilos para mobile
  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      gap: '2rem',
      maxWidth: '1400px',
      alignItems: 'flex-start'
    }
  },
  sidebar: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    [theme.breakpoints.up('md')]: {
      width: '350px'
    }
  },
  mainContent: {
    flex: 1,
    width: '100%'
  },
  mobileTitle: {
    fontSize: '1.5rem',
    textAlign: 'center',
    width: '100%',
    marginBottom: '1rem',
    color: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
      ? '#FFFFFF'
      : theme.palette.text.primary,
    [theme.breakpoints.up('md')]: {
      fontSize: '2.125rem',
      marginBottom: '2rem'
    }
  },
  mobileButton: {
    padding: '10px 20px',
    background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
    borderRadius: 25,
    color: '#FFFFFF',
    '&:hover': {
      background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
      color: '#FFFFFF',
    },
    [theme.breakpoints.up('md')]: {
      padding: '12px 24px'
    }
  },
  mobilePaper: {
    padding: '1rem',
    [theme.breakpoints.up('md')]: {
      padding: '1.5rem'
    }
  },
  navigationButton: {
    padding: '12px 16px',
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
    justifyContent: 'flex-start',
    marginBottom: '8px',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
    }
  },
  dashboardButton: {
    backgroundColor: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
      ? theme.palette.primary.dark
      : theme.palette.primary.main,
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
        ? theme.palette.primary.main
        : theme.palette.primary.dark,
    }
  },
  archiveButton: {
    backgroundColor: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
      ? theme.palette.primary.dark
      : theme.palette.primary.main,
    color: '#FFFFFF',
    border: 'none',
    '&:hover': {
      backgroundColor: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
        ? theme.palette.primary.main
        : theme.palette.primary.dark,
    }
  },
  mobileButtonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row'
    }
  },
  taskItemMobile: {
    marginBottom: '8px',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    },
    [theme.breakpoints.down('sm')]: {
      padding: '8px'
    }
  },
  taskTextMobile: {
    // Reserva espaço para os botões de ação à direita
    paddingRight: 128,
    wordBreak: 'break-word',
    [theme.breakpoints.up('md')]: {
      paddingRight: 160
    },
    [theme.breakpoints.down('sm')]: {
      '& .MuiListItemText-primary': {
        fontSize: '0.9rem'
      },
      '& .MuiListItemText-secondary': {
        fontSize: '0.8rem'
      }
    }
  },
  mobileActions: {
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
  minWidth: 120,
  justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '2px',
      '& .MuiIconButton-root': {
        padding: '6px'
      }
    }
  },
  chipContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '4px',
    [theme.breakpoints.down('sm')]: {
      gap: '2px',
      '& .MuiChip-root': {
        height: '20px',
        fontSize: '0.7rem'
      }
    }
  },
  descriptionClamp: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    whiteSpace: 'normal'
  },
  // Estilos para os ícones de tarefas com badges
  taskIconsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2), // Maior espaçamento entre ícones
    marginTop: theme.spacing(1),
    '& .MuiBadge-root': {
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'scale(1.1)'
      }
    }
  },
  commentIcon: {
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.primary.dark
    }
  },
  attachmentIcon: {
    color: theme.palette.secondary.main,
    '&:hover': {
      color: theme.palette.secondary.dark
    }
  },
  subtaskIcon: {
    color: theme.palette.warning.main,
    '&:hover': {
      color: theme.palette.warning.dark
    }
  },
  // Badge customizado para subtarefas
  subtaskBadge: {
    '& .MuiBadge-badge': {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.warning.contrastText,
      fontWeight: 600,
      fontSize: '0.75rem',
      right: -8,
      top: 8
    }
  },
  // Badges customizados para comentários e anexos
  commentBadge: {
    '& .MuiBadge-badge': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      fontWeight: 600,
      fontSize: '0.75rem',
      right: -8,
      top: 8
    }
  },
  attachmentBadge: {
    '& .MuiBadge-badge': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
      fontWeight: 600,
      fontSize: '0.75rem',
      right: -8,
      top: 8
    }
  },
  // Estilos para seções de tarefas
  taskSection: {
    marginBottom: theme.spacing(3),
    '&:last-child': {
      marginBottom: 0
    }
  },
  sectionHeader: {
    padding: theme.spacing(2),
    backgroundColor: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
      ? 'rgba(0,0,0,0.3)'
      : theme.palette.grey[50],
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    position: 'sticky',
    top: 0,
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5)
    }
  },
  sectionIcon: {
    fontSize: '1.2rem'
  },
  privateIcon: {
    color: theme.palette.warning.main
  },
  publicIcon: {
    color: theme.palette.success.main
  },
  visibilityChip: {
    marginLeft: '8px',
    height: '20px',
    fontSize: '0.7rem'
  },
  privateChip: {
    backgroundColor: theme.palette.warning.light,
    color: '#FFFFFF',
    '& .MuiChip-icon': {
      color: '#FFFFFF'
    }
  },
  publicChip: {
    backgroundColor: theme.palette.success.light,
    color: '#FFFFFF',
    '& .MuiChip-icon': {
      color: '#FFFFFF'
    }
  },
  // Nova seção para as tags/chips reorganizadas
  tagsContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '6px',
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    borderTop: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('sm')]: {
      gap: '4px',
      marginTop: theme.spacing(0.5)
    }
  },
  // Padronização de tamanho para todos os chips
  standardChip: {
    height: '24px',
    fontSize: '0.75rem',
    fontWeight: 500,
    color: '#FFFFFF',
    '& .MuiChip-label': {
      color: '#FFFFFF'
    },
    '& .MuiChip-icon': {
      color: '#FFFFFF'
    },
    [theme.breakpoints.down('sm')]: {
      height: '20px',
      fontSize: '0.7rem'
    }
  },
  recurringChip: {
    backgroundColor: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
      ? 'rgba(33,150,243,0.8)'
      : 'rgba(33,150,243,0.9)',
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      backgroundColor: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
        ? 'rgba(33,150,243,0.9)'
        : theme.palette.primary.main,
    }
  }
}));

const ToDoList = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [filters, setFilters] = useState({
    searchParam: '',
    status: '',
    priority: '',
    category: '',
    dueDateFrom: '',
    dueDateTo: '',
    sortBy: 'createdAt',
    sortOrder: 'DESC',
    onlyAssigned: false
  });
  
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [totalTasks, setTotalTasks] = useState(0);

  // Novos estados para funcionalidades completas
  const [taskCounts, setTaskCounts] = useState({});
  const [advancedFilters, setAdvancedFilters] = useState({
    hasComments: false,
    hasAttachments: false,
    hasSubtasks: false,
    overdueOnly: false,
    todayOnly: false,
    tomorrowOnly: false,
    privateOnly: false,
    publicOnly: false
  });
  const [quickFilterDialog, setQuickFilterDialog] = useState(false);
  
  // Novos estados para o modal unificado
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [editingTaskData, setEditingTaskData] = useState(null);

  // Estados para modal de confirmação de exclusão com recorrência
  const [recurrenceDeleteModal, setRecurrenceDeleteModal] = useState({
    open: false,
    taskId: null,
    taskTitle: '',
    recurrenceInfo: null,
    allowStopRecurrence: true,
    allowDeleteFuture: false,
    initialStopRecurrence: true,
    initialDeleteFuture: false
  });

  // Estado para modal de confirmação de exclusão simples
  const [deleteConfirmModal, setDeleteConfirmModal] = useState({
    open: false,
    taskId: null,
    taskTitle: ''
  });

  // Estado para modal de confirmação de arquivamento
  const [archiveConfirmModal, setArchiveConfirmModal] = useState({
    open: false,
    taskId: null,
    taskTitle: '',
    isCurrentlyArchived: false
  });

  const [selectedTaskIds, setSelectedTaskIds] = useState([]);
  const [bulkDeleteModal, setBulkDeleteModal] = useState({
    open: false,
    taskIds: [],
    includeStopRecurrence: false,
    includeDeleteFuture: false,
    total: 0,
    recurringCount: 0
  });

  // Colapsar filtros por padrão no mobile
  useEffect(() => {
    if (isMobile) {
      setShowFilters(false);
    }
  }, [isMobile]);

  // Carregar tarefas ao montar o componente ou quando filtros mudarem
  useEffect(() => {
    loadTasks();
  }, [filters]);

  // Monitorar mudanças nos filtros avançados
  useEffect(() => {
    // Força uma re-renderização dos componentes que dependem dos filtros
    if (tasks.length > 0) {
      console.log('🔄 Forçando re-aplicação dos filtros avançados');
    }
  }, [advancedFilters, tasks]);

  // Carregar contadores de comentários, anexos e subtarefas
  useEffect(() => {
    if (tasks.length > 0) {
      loadTaskCounts();
    }
  }, [tasks]);

  // Effect para conexão com o socket e registro de listeners
  useEffect(() => {
    if (!user?.companyId || !user?.id) return;
    const io = socketConnection({ user });
    if (!io) return;

    let debounceTimer = null;
    const refresh = () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        loadTasks();
      }, 200);
    };

    const channel = `company-${user.companyId}-task`;
    const handler = (data) => {
      const actions = ["create", "update", "delete", "assignee:add", "assignee:remove"];
      if (data && actions.includes(data.action)) {
        refresh();
      }
    };

    io.on(channel, handler);

    return () => {
      io.off(channel, handler);
      if (debounceTimer) clearTimeout(debounceTimer);
    };
  }, [user?.companyId, user?.id]);

  const loadTasks = async () => {
    try {
      setLoading(true);
      
      // Preparar parâmetros de filtro
      const params = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});
      
      // ToDoList sempre mostra apenas tarefas não arquivadas
      params.isArchived = false;
      
      // Se onlyAssigned estiver true, garantir envio como 'true'
      if (params.onlyAssigned === true) {
        params.onlyAssigned = true;
      }
      
      const response = await taskService.getAll(params);
      
      console.log('=== RESPOSTA DO BACKEND ===');
      console.log('Total de tarefas:', response.tasks?.length);
      console.log('Tarefas recebidas:', response.tasks?.map(t => ({ 
        id: t.id, 
        title: t.title, 
        isArchived: t.isArchived,
        isPublic: t.isPublic,
        userId: t.userId,
        user: t.user,
        createdBy: t.createdBy,
        author: t.author
      })));
      
      // Garantir que apenas tarefas não arquivadas sejam exibidas (filtro de segurança)
      let filteredTasks = (response.tasks || []).filter(t => !t.isArchived);
      
      console.log('📊 Análise da resposta:');
      console.log('- Total após filtro de não arquivadas:', filteredTasks.length);
      
      
      setTasks(filteredTasks);
      setSelectedTaskIds((prev) => prev.filter((id) => filteredTasks.some((task) => task.id === id)));
      setTotalTasks(filteredTasks.length); // Usar contagem filtrada
    } catch (error) {
      console.error('Erro ao carregar tarefas:', error);
      toast.error('Erro ao carregar tarefas');
    } finally {
      setLoading(false);
    }
  };

  const loadTaskCounts = async () => {
    try {
      const counts = {};
      for (const task of tasks) {
        try {
          // Carregar contadores para cada tarefa
          const [commentsRes, attachmentsRes, subtasksRes] = await Promise.all([
            taskService.getComments(task.id).catch(() => ({ comments: [] })),
            taskService.getAttachments(task.id).catch(() => []),
            taskService.getSubtasks(task.id).catch(() => ({ subtasks: [] }))
          ]);
          
          counts[task.id] = {
            comments: commentsRes.comments?.length || 0,
            attachments: attachmentsRes.attachments?.length || attachmentsRes?.length || 0, // Adicionar fallback
            subtasks: subtasksRes.subtasks?.length || 0
          };
        } catch (error) {
          console.log(`Erro ao carregar contadores para tarefa ${task.id}:`, error);
          counts[task.id] = { comments: 0, attachments: 0, subtasks: 0 };
        }
      }
      setTaskCounts(counts);
    } catch (error) {
      console.error('Erro ao carregar contadores:', error);
    }
  };

  const applyAdvancedFilters = (taskList) => {
    console.log('=== DEBUG FILTROS AVANÇADOS ===');
    console.log('Lista original:', taskList?.length, 'tarefas');
    console.log('Filtros avançados ativos:', Object.entries(advancedFilters).filter(([k,v]) => v));
    
    let filtered = [...taskList];

    // Aplicar filtros avançados (filtro de arquivo já foi feito no loadTasks)
    if (advancedFilters.hasComments) {
      filtered = filtered.filter(task => taskCounts[task.id]?.comments > 0);
      console.log('📝 Filtro comentários:', filtered.length, 'tarefas');
    }
    if (advancedFilters.hasAttachments) {
      filtered = filtered.filter(task => taskCounts[task.id]?.attachments > 0);
      console.log('📎 Filtro anexos:', filtered.length, 'tarefas');
    }
    if (advancedFilters.hasSubtasks) {
      filtered = filtered.filter(task => taskCounts[task.id]?.subtasks > 0);
      console.log('📋 Filtro subtarefas:', filtered.length, 'tarefas');
    }
    if (advancedFilters.overdueOnly) {
      filtered = filtered.filter(task => task.dueDate && isPast(parseISO(task.dueDate)));
      console.log('⏰ Filtro atrasadas:', filtered.length, 'tarefas');
    }
    if (advancedFilters.todayOnly) {
      filtered = filtered.filter(task => task.dueDate && isToday(parseISO(task.dueDate)));
      console.log('📅 Filtro hoje:', filtered.length, 'tarefas');
    }
    if (advancedFilters.tomorrowOnly) {
      filtered = filtered.filter(task => task.dueDate && isTomorrow(parseISO(task.dueDate)));
      console.log('📆 Filtro amanhã:', filtered.length, 'tarefas');
    }
    if (advancedFilters.privateOnly) {
      filtered = filtered.filter(task => !task.isPublic);
      console.log('🔒 Filtro privadas:', filtered.length, 'tarefas');
    }
    if (advancedFilters.publicOnly) {
      filtered = filtered.filter(task => task.isPublic);
      console.log('🌐 Filtro públicas:', filtered.length, 'tarefas');
    }

    console.log('🎯 Lista final filtrada:', filtered?.length, 'tarefas');
    console.log('=== FIM DEBUG FILTROS AVANÇADOS ===');
    return filtered;
  };

  const getFilteredTasks = () => {
    return applyAdvancedFilters(tasks);
  };

  // Função para separar tarefas em públicas e privadas
  const getSeparatedTasks = () => {
    const filteredTasks = getFilteredTasks();
    const privateTasks = filteredTasks.filter(task => !task.isPublic);
    const publicTasks = filteredTasks.filter(task => task.isPublic);
    
    return {
      privateTasks,
      publicTasks,
      totalPrivate: privateTasks.length,
      totalPublic: publicTasks.length
    };
  };

  // Função para verificar se o usuário pode excluir a tarefa
  const canDeleteTask = (task) => {
    // Se a tarefa é privada, sempre pode excluir (assumindo que só vê suas próprias tarefas privadas)
    if (!task.isPublic) {
      return true;
    }
    
    // Se a tarefa é pública, só pode excluir se for o criador
    return task.userId === user.id;
  };

  // Função para obter o nome do criador da tarefa
  const getTaskCreatorName = (task) => {
    // Tentar diferentes propriedades onde o nome do usuário pode estar
    if (task.user?.name) return task.user.name;
    if (task.createdBy?.name) return task.createdBy.name;
    if (task.author?.name) return task.author.name;
    if (task.userName) return task.userName;
    if (task.createdByName) return task.createdByName;
    
    // Se não encontrar o nome, retornar um padrão
    return 'Usuário';
  };

  // Função para renderizar uma seção de tarefas
  const renderTaskSection = (tasks, sectionTitle, isPublic, startIndex = 0) => {
    if (tasks.length === 0) return null;

    return (
      <div className={classes.taskSection} key={sectionTitle}>
        <div className={classes.sectionHeader}>
          {isPublic ? (
            <PublicIcon className={`${classes.sectionIcon} ${classes.publicIcon}`} />
          ) : (
            <LockIcon className={`${classes.sectionIcon} ${classes.privateIcon}`} />
          )}
          <Typography variant="h6" style={{ fontWeight: 600 }}>
            {sectionTitle} ({tasks.length})
          </Typography>
        </div>
        
        <List>
          {tasks.map((task, index) => (
            <Draggable 
              key={task.id} 
              draggableId={task.id.toString()} 
              index={startIndex + index}
            >
              {(provided, snapshot) => (
                <ListItem 
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  className={`${classes.taskItemMobile} ${task.status === 'completed' ? classes.completedTask : ''} ${task.isArchived ? classes.archivedTask : ''} ${snapshot.isDragging ? classes.dragging : ''} ${isTaskSelected(task.id) ? classes.selectedTask : ''}`}
                >
                  <ListItemIcon {...provided.dragHandleProps}>
                    <DragIndicatorIcon className={classes.dragHandle} />
                  </ListItemIcon>
                  <Checkbox
                    edge="start"
                    color="primary"
                    checked={isTaskSelected(task.id)}
                    onChange={() => toggleTaskSelection(task.id)}
                    disabled={!canSelectTask(task) || loading}
                    style={{ marginRight: '8px' }}
                  />
                  <ListItemText
                    className={classes.taskTextMobile}
                    primary={
                      <div>
                        <span style={{ fontWeight: 500 }}>{task.title}</span>
                      </div>
                    }
                    secondary={
                      <div>
                        {task.description && (
                          <div className={classes.descriptionClamp} title={task.description}>
                            {task.description}
                          </div>
                        )}
                        <div style={{ fontSize: '0.75rem', marginTop: '4px' }}>
                          Criado: {new Date(task.createdAt).toLocaleString()}
                          {task.isPublic && (
                            <span> | 👤 Por: {getTaskCreatorName(task)}</span>
                          )}
                          {task.dueDate && (
                            <span> | 📅 Vencimento: {new Date(task.dueDate).toLocaleDateString()} {new Date(task.dueDate).getHours() !== 23 || new Date(task.dueDate).getMinutes() !== 59 ? `🕐 ${new Date(task.dueDate).toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'})}` : ''}</span>
                          )}
                        </div>
                        {/* Contadores de funcionalidades */}
                        <Box className={classes.taskIconsContainer}>
                          {taskCounts[task.id]?.comments > 0 && (
                            <Tooltip title={`${taskCounts[task.id].comments} comentário(s)`} arrow>
                              <Badge 
                                badgeContent={taskCounts[task.id].comments} 
                                className={classes.commentBadge}
                                overlap="circular"
                              >
                                <CommentIcon 
                                  fontSize="small" 
                                  className={classes.commentIcon}
                                />
                              </Badge>
                            </Tooltip>
                          )}
                          {taskCounts[task.id]?.attachments > 0 && (
                            <Tooltip title={`${taskCounts[task.id].attachments} anexo(s)`} arrow>
                              <Badge 
                                badgeContent={taskCounts[task.id].attachments} 
                                className={classes.attachmentBadge}
                                overlap="circular"
                              >
                                <AttachFileIcon 
                                  fontSize="small" 
                                  className={classes.attachmentIcon}
                                />
                              </Badge>
                            </Tooltip>
                          )}
                          {taskCounts[task.id]?.subtasks > 0 && (
                            <Tooltip title={`${taskCounts[task.id].subtasks} subtarefa(s)`} arrow>
                              <Badge 
                                badgeContent={taskCounts[task.id].subtasks} 
                                className={classes.subtaskBadge}
                                overlap="circular"
                              >
                                <AccountTreeIcon 
                                  fontSize="small" 
                                  className={classes.subtaskIcon}
                                />
                              </Badge>
                            </Tooltip>
                          )}
                        </Box>
                        {/* Seção de Tags/Chips reorganizada */}
                        <div className={classes.tagsContainer}>
                          <Chip
                            label={getPriorityLabel(task.priority)}
                            color={getPriorityColor(task.priority)}
                            size="small"
                            className={classes.standardChip}
                          />
                          <Chip
                            label={task.status === 'completed' ? 'Concluída' : 'Pendente'}
                            color={task.status === 'completed' ? 'default' : 'primary'}
                            size="small"
                            variant={task.status === 'completed' ? 'outlined' : 'default'}
                            className={classes.standardChip}
                          />
                          <Chip
                            icon={task.isPublic ? <PublicIcon /> : <LockIcon />}
                            label={task.isPublic ? 'Pública' : 'Privada'}
                            size="small"
                            className={`${classes.standardChip} ${task.isPublic ? classes.publicChip : classes.privateChip}`}
                          />
                          {getTaskAlertChip(task)}
                          {task.category && (
                            <Chip
                              label={getCategoryLabel(task.category)}
                              size="small"
                              className={`${classes.standardChip} ${classes.categoryChip}`}
                            />
                          )}
                          {task.isRecurring && (
                            <Chip
                              icon={<RepeatIcon />}
                              label="🔄 Recorrente"
                              size="small"
                              className={`${classes.standardChip} ${classes.recurringChip}`}
                            />
                          )}
                          {task.isArchived && (
                            <Chip
                              icon={<ArchiveIcon />}
                              label="Arquivada"
                              size="small"
                              className={classes.standardChip}
                              style={{
                                backgroundColor: '#795548',
                                color: '#fff'
                              }}
                            />
                          )}
                          {Array.isArray(task.assignees) && task.assignees.length > 0 && (
                            <>
                              {task.assignees.map(a => (
                                <Chip
                                  key={`assignee-${task.id}-${a.user?.id || a.userId}`}
                                  label={a.user?.name || `Usuário ${a.userId}`}
                                  size="small"
                                  className={classes.standardChip}
                                  style={{ backgroundColor: '#607d8b' }}
                                />
                              ))}
                            </>
                          )}
                        </div>
                      </div>
                    }
                  />
                  <ListItemSecondaryAction>
                    <div className={classes.mobileActions}>
                      <IconButton 
                        onClick={() => handleToggleStatus(task)}
                        disabled={loading}
                        title={task.status === 'completed' ? 'Marcar como pendente' : 'Marcar como concluída'}
                        size="small"
                      >
                        {task.status === 'completed' ? <UndoIcon /> : <CheckIcon />}
                      </IconButton>
                      <IconButton 
                        onClick={() => handleOpenFormModal(task)}
                        disabled={loading}
                        title="Abrir tarefa (visualizar/editar tudo)"
                        size="small"
                      >
                        <OpenInNewIcon />
                      </IconButton>
                      {task.isRecurring && (
                        <IconButton 
                          onClick={() => handleStopRecurrence(task.id)}
                          disabled={loading}
                          title="Parar recorrência"
                          size="small"
                        >
                          <StopIcon />
                        </IconButton>
                      )}
                      <IconButton 
                        onClick={() => handleArchiveTask(task.id, task.isArchived)}
                        disabled={loading}
                        title={task.isArchived ? 'Desarquivar tarefa' : 'Arquivar tarefa'}
                        size="small"
                      >
                        {task.isArchived ? <UnarchiveIcon /> : <ArchiveIcon />}
                      </IconButton>
                      <IconButton 
                        onClick={() => handleDelete(task.id)}
                        disabled={loading || !canDeleteTask(task)}
                        title={
                          !canDeleteTask(task) 
                            ? "Só pode ser deletada pelo criador" 
                            : "Excluir tarefa"
                        }
                        size="small"
                        style={{
                          opacity: canDeleteTask(task) ? 1 : 0.5
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </div>
                  </ListItemSecondaryAction>
                </ListItem>
              )}
            </Draggable>
          ))}
        </List>
      </div>
    );
  };

  const getTaskAlertChip = (task) => {
    if (!task.dueDate) return null;
    
    const dueDate = parseISO(task.dueDate);
    const chipClass = classes.standardChip;
    
    if (isPast(dueDate) && task.status !== 'completed') {
      return <Chip size="small" icon={<WarningIcon />} label="Atrasada" color="secondary" className={chipClass} />;
    }
    if (isToday(dueDate)) {
      return <Chip size="small" icon={<TodayIcon />} label="Hoje" color="primary" className={chipClass} />;
    }
    if (isTomorrow(dueDate)) {
      return <Chip size="small" icon={<EventIcon />} label="Amanhã" className={chipClass} />;
    }
    
    return null;
  };

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const clearFilters = () => {
    setFilters({
      searchParam: '',
      status: '',
      priority: '',
      category: '',
      dueDateFrom: '',
      dueDateTo: '',
      sortBy: 'createdAt',
      sortOrder: 'DESC',
      onlyAssigned: false
    });
  };

  const getActiveFiltersCount = () => {
    return Object.entries(filters).filter(([key, value]) => {
      if (key === 'sortBy' && value === 'createdAt') return false;
      if (key === 'sortOrder' && value === 'DESC') return false;
      return value && value !== '';
    }).length;
  };

  const handleDelete = async (taskId) => {
    // Encontrar a tarefa para obter o título
    const task = tasks.find(t => t.id === taskId);
    
    // Verificar se o usuário pode excluir esta tarefa
    if (!canDeleteTask(task)) {
      toast.error('Só pode ser deletada pelo criador.');
      return;
    }
    
    // Abrir modal de confirmação
    setDeleteConfirmModal({
      open: true,
      taskId: taskId,
      taskTitle: task?.title || 'Tarefa'
    });
  };

  const handleConfirmDelete = async () => {
    const { taskId } = deleteConfirmModal;
    
    try {
      setLoading(true);
      
      // Verificar se a tarefa é recorrente antes de tentar deletar
      const task = tasks.find(t => t.id === taskId);
      
      // Se a tarefa é recorrente, mostrar o modal específico diretamente
      if (task && task.isRecurring) {
        // Calcular quantas tarefas recorrentes estão pendentes
        const pendingRecurrentTasks = tasks.filter(t => 
          t.recurrenceId === task.recurrenceId && 
          t.status === 'pending'
        ).length;

        setRecurrenceDeleteModal({
          open: true,
          taskId: taskId,
          taskTitle: task?.title || 'Tarefa',
          recurrenceInfo: {
            recurrenceType: task.recurrenceType || 'daily',
            recurrenceInterval: task.recurrenceInterval || 1,
            recurrenceCount: task.recurrenceCount,
            recurrenceEndDate: task.recurrenceEndDate,
            pendingCount: pendingRecurrentTasks > 0 ? pendingRecurrentTasks : 1,
            nextDueDate: task.dueDate,
            totalGenerated: pendingRecurrentTasks
          },
          allowStopRecurrence: true,
          allowDeleteFuture: true,
          initialStopRecurrence: true,
          initialDeleteFuture: false
        });
        // Fechar modal de confirmação simples
        setDeleteConfirmModal({ open: false, taskId: null, taskTitle: '' });
        setLoading(false);
        return;
      }
      
      // Tentar deletar normalmente primeiro (para tarefas não recorrentes)
      const result = await taskService.delete(taskId);
      
      // Se retornou conflito de recorrência (fallback caso o frontend não detecte), mostrar modal específico
      if (result && result.hasRecurrenceConflict) {
        setRecurrenceDeleteModal({
          open: true,
          taskId: taskId,
          taskTitle: task?.title || 'Tarefa',
          recurrenceInfo: result.recurrenceInfo,
          allowStopRecurrence: true,
          allowDeleteFuture: true,
          initialStopRecurrence: true,
          initialDeleteFuture: false
        });
        // Fechar modal de confirmação simples
        setDeleteConfirmModal({ open: false, taskId: null, taskTitle: '' });
        setLoading(false);
        return;
      }
      
      // Se chegou aqui, deletou normalmente
      toast.success('Tarefa excluída com sucesso!');
      await loadTasks();
      
      // Fechar modal de confirmação
      setDeleteConfirmModal({ open: false, taskId: null, taskTitle: '' });
      
    } catch (error) {
      console.error('Erro ao excluir tarefa:', error);
      toast.error('Erro ao excluir tarefa');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelDelete = () => {
    setDeleteConfirmModal({ open: false, taskId: null, taskTitle: '' });
  };

  const handleConfirmRecurrenceDelete = async ({ mode } = { mode: 'single' }) => {
    const { taskId } = recurrenceDeleteModal;
    if (!taskId) {
      toast.error('Não foi possível identificar a tarefa selecionada.');
      return;
    }

    const payload = {
      forceDelete: true,
      stopRecurrence: mode !== 'single',
      deleteFutureOccurrences: mode !== 'single',
      deleteEntireSeries: mode === 'all'
    };

    if (mode === 'future') {
      payload.fromDate = recurrenceDeleteModal.recurrenceInfo?.nextDueDate || null;
    }

    try {
      await taskService.delete(taskId, payload);
      toast.success('Tarefa excluída com sucesso.');
      await loadTasks();
      setRecurrenceDeleteModal({
        open: false,
        taskId: null,
        taskTitle: '',
        recurrenceInfo: null,
        allowStopRecurrence: false,
        allowDeleteFuture: false,
        initialStopRecurrence: true,
        initialDeleteFuture: false
      });
    } catch (error) {
      console.error('Erro ao excluir tarefa com recorrência:', error);
      toast.error('Erro ao excluir tarefa');
      throw error;
    }
  };

  const handleCloseRecurrenceModal = () => {
    setRecurrenceDeleteModal({
      open: false,
      taskId: null,
      taskTitle: '',
      recurrenceInfo: null,
      allowStopRecurrence: true,
      allowDeleteFuture: false,
      initialStopRecurrence: true,
      initialDeleteFuture: false
    });
  };

  const handleStopRecurrence = async (taskId) => {
    if (!window.confirm('Tem certeza que deseja parar a recorrência desta tarefa?')) {
      return;
    }

    try {
      setLoading(true);
      await taskRecurrenceService.stopRecurrence(taskId);
      toast.success('Recorrência parada com sucesso!');
      await loadTasks();
    } catch (error) {
      console.error('Erro ao parar recorrência:', error);
      toast.error('Erro ao parar recorrência');
    } finally {
      setLoading(false);
    }
  };

  const handleArchiveTask = async (taskId, isCurrentlyArchived) => {
    // Encontrar a tarefa para obter o título
    const task = tasks.find(t => t.id === taskId);
    
    // Abrir modal de confirmação de arquivamento
    setArchiveConfirmModal({
      open: true,
      taskId: taskId,
      taskTitle: task?.title || 'Tarefa',
      isCurrentlyArchived: isCurrentlyArchived
    });
  };

  const handleConfirmArchive = async () => {
    const { taskId, isCurrentlyArchived } = archiveConfirmModal;
    const action = isCurrentlyArchived ? 'desarquivar' : 'arquivar';
    
    console.log('=== ARQUIVAMENTO DE TAREFA ===');
    console.log('🆔 ID da tarefa:', taskId);
    console.log('📦 Estado atual (arquivada):', isCurrentlyArchived);
    console.log('🎯 Ação a realizar:', action);
    console.log('🔄 Novo valor isArchived:', !isCurrentlyArchived);

    try {
      setLoading(true);
      
      console.log('📤 Enviando para backend:', { isArchived: !isCurrentlyArchived });
      const response = await taskService.update(taskId, { isArchived: !isCurrentlyArchived });
      console.log('📥 Resposta do backend:', response);
      
      toast.success(`Tarefa ${isCurrentlyArchived ? 'desarquivada' : 'arquivada'} com sucesso!`);
      
      console.log('🔄 Recarregando lista de tarefas...');
      await loadTasks();
      console.log('✅ Lista recarregada com sucesso');
      
      // Fechar modal de confirmação
      setArchiveConfirmModal({ open: false, taskId: null, taskTitle: '', isCurrentlyArchived: false });
      
    } catch (error) {
      console.error('❌ Erro ao arquivar tarefa:', error);
      console.error('📋 Detalhes do erro:', error.response?.data);
      toast.error(`Erro ao ${action} tarefa`);
    } finally {
      setLoading(false);
      console.log('=== FIM ARQUIVAMENTO ===');
    }
  };

  const canSelectTask = (task) => canDeleteTask(task) && task.status !== 'completed';

  const isTaskSelected = (taskId) => selectedTaskIds.includes(taskId);

  const toggleTaskSelection = (taskId) => {
    setSelectedTaskIds((prev) =>
      prev.includes(taskId) ? prev.filter((id) => id !== taskId) : [...prev, taskId]
    );
  };

  const selectAllVisibleTasks = () => {
    const visibleTasks = getFilteredTasks()
      .filter((task) => canSelectTask(task))
      .map((task) => task.id);
    setSelectedTaskIds(visibleTasks);
  };

  const clearTaskSelection = () => {
    setSelectedTaskIds([]);
  };

  const handleBulkDeleteRequest = () => {
    if (selectedTaskIds.length === 0) {
      toast.info('Selecione ao menos uma tarefa para excluir.');
      return;
    }

    const selectedData = tasks.filter((task) => selectedTaskIds.includes(task.id));
    const recurringCount = selectedData.filter((task) => task.isRecurring).length;

    setBulkDeleteModal({
      open: true,
      taskIds: selectedTaskIds,
      includeStopRecurrence: recurringCount > 0,
      includeDeleteFuture: false,
      total: selectedData.length,
      recurringCount
    });
  };

  const handleCloseBulkDeleteModal = () => {
    setBulkDeleteModal({
      open: false,
      taskIds: [],
      includeStopRecurrence: false,
      includeDeleteFuture: false,
      total: 0,
      recurringCount: 0
    });
  };

  const handleConfirmBulkDelete = async () => {
    if (bulkDeleteModal.taskIds.length === 0) {
      handleCloseBulkDeleteModal();
      return;
    }

    try {
      setLoading(true);
      const result = await taskService.bulkDelete(bulkDeleteModal.taskIds, {
        forceDelete: true,
        stopRecurrence: bulkDeleteModal.includeStopRecurrence,
        deleteFutureOccurrences: bulkDeleteModal.includeDeleteFuture
      });

      if (result?.removed?.length) {
        toast.success(`Excluídas ${result.removed.length} tarefa(s).`);
      }

      if (result?.errors?.length) {
        toast.warn(`${result.errors.length} tarefa(s) não puderam ser removidas.`);
      }

      await loadTasks();
      clearTaskSelection();
    } catch (error) {
      console.error('Erro ao excluir tarefas em lote:', error);
      toast.error('Erro ao excluir tarefas em lote');
    } finally {
      setLoading(false);
      handleCloseBulkDeleteModal();
    }
  };

  const handleCancelArchive = () => {
    setArchiveConfirmModal({ open: false, taskId: null, taskTitle: '', isCurrentlyArchived: false });
  };

  const handleToggleStatus = async (task) => {
    try {
      setLoading(true);
      const newStatus = task.status === 'pending' ? 'completed' : 'pending';
      await taskService.update(task.id, { status: newStatus });
      toast.success(`Tarefa ${newStatus === 'completed' ? 'concluída' : 'reaberta'}!`);
      await loadTasks();
    } catch (error) {
      console.error('Erro ao alterar status:', error);
      toast.error('Erro ao alterar status da tarefa');
    } finally {
      setLoading(false);
    }
  };

  const handleDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    const { source, destination } = result;
    
    if (source.index === destination.index) {
      return;
    }

    try {
      // Reordenar localmente primeiro para feedback visual imediato
      const newTasks = Array.from(tasks);
      const [removed] = newTasks.splice(source.index, 1);
      newTasks.splice(destination.index, 0, removed);
      setTasks(newTasks);

      // Enviar para o backend
      const taskId = removed.id;
      const newSortOrder = destination.index + 1; // Baseado em 1

      await taskReorderService.reorderTask(taskId, newSortOrder);
      
      // Recarregar para garantir consistência
      await loadTasks();
      
    } catch (error) {
      console.error('Erro ao reordenar tarefa:', error);
      toast.error('Erro ao reordenar tarefa');
      // Recarregar em caso de erro
      await loadTasks();
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'secondary';
      case 'medium': return 'primary';
      case 'low': return 'default';
      default: return 'default';
    }
  };

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case 'high': return 'Alta';
      case 'medium': return 'Média';
      case 'low': return 'Baixa';
      default: return priority;
    }
  };



  const handleExportPDF = async () => {
    try {
      setLoading(true);
      await taskService.exportPDF(filters);
      toast.success('PDF exportado com sucesso!');
    } catch (error) {
      console.error('Erro ao exportar PDF:', error);
      toast.error('Erro ao exportar PDF');
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    try {
      setLoading(true);
      await taskService.exportExcel(filters);
      toast.success('Excel exportado com sucesso!');
    } catch (error) {
      console.error('Erro ao exportar Excel:', error);
      toast.error('Erro ao exportar Excel');
    } finally {
      setLoading(false);
    }
  };

  // Novas funções para o modal unificado
  const handleOpenFormModal = async (task = null) => {
    if (task && task.id) {
      try {
        console.log('[MODAL] Carregando dados completos da tarefa:', task.id);
        setLoading(true);
        
        // Carregar dados completos da tarefa individualmente para debug
        console.log('[MODAL] 1. Carregando dados básicos da tarefa...');
        const taskData = await taskService.getById(task.id);
        console.log('[MODAL] Dados básicos carregados:', taskData);
        
        console.log('[MODAL] 2. Carregando subtarefas...');
        const subtasks = await taskService.getSubtasks(task.id);
        console.log('[MODAL] Subtarefas carregadas:', subtasks);
        
        console.log('[MODAL] 3. Carregando comentários...');
        const comments = await taskService.getComments(task.id);
        console.log('[MODAL] Comentários carregados:', comments);
        
        console.log('[MODAL] 4. Carregando anexos...');
        const attachments = await taskService.getAttachments(task.id);
        console.log('[MODAL] Anexos carregados:', attachments);
        
        // Combinar todos os dados
        const completeTaskData = {
          ...taskData,
          subtasks: subtasks.subtasks || [],
          comments: comments.comments || [],
          attachments: attachments.attachments || attachments || [] // Adicionar fallback para attachments diretamente
        };
        
        console.log('[MODAL] Dados completos combinados:', completeTaskData);
        console.log('[MODAL] 🔍 VERIFICANDO NOTIFICAÇÕES:', {
          id: completeTaskData.id,
          title: completeTaskData.title,
          reminderEnabled: completeTaskData.reminderEnabled,
          notificationsEnabled: completeTaskData.notificationsEnabled,
          reminderDate: completeTaskData.reminderDate
        });
        console.log('[MODAL] Anexos detalhados:', completeTaskData.attachments);
        console.log('[MODAL] Quantidade de anexos:', completeTaskData.attachments?.length);
        setEditingTaskData(completeTaskData);
      } catch (error) {
        console.error('[MODAL] Erro ao carregar dados da tarefa:', error);
        toast.error('Erro ao carregar dados da tarefa');
        setEditingTaskData(task); // Fallback para dados básicos
      } finally {
        setLoading(false);
      }
    } else {
      console.log('[MODAL] Criando nova tarefa');
      setEditingTaskData(task);
    }
    setFormModalOpen(true);
  };

  const handleCloseFormModal = () => {
    setFormModalOpen(false);
    setEditingTaskData(null);
  };

  // Função utilitária para validar e limpar datas inválidas
  const cleanInvalidDates = (data) => {
    const cleaned = { ...data };
    
    // Lista de campos de data que precisam ser validados
    const dateFields = ['dueDate', 'reminderDate', 'recurrenceEndDate'];
    
    dateFields.forEach(field => {
      if (cleaned[field] === 'Invalid date' || cleaned[field] === '' || cleaned[field] === 'undefined' || !cleaned[field]) {
        cleaned[field] = null;
      } else if (cleaned[field] && cleaned[field] !== null) {
        // Validar se é uma data válida
        const testDate = new Date(cleaned[field]);
        if (isNaN(testDate.getTime())) {
          console.warn(`Data inválida detectada no campo ${field}:`, cleaned[field]);
          cleaned[field] = null;
        }
      }
    });
    
    // Validações específicas para recorrência
    if (cleaned.isRecurring) {
      // Validar recurrenceInterval
      if (!cleaned.recurrenceInterval || cleaned.recurrenceInterval <= 0) {
        console.warn('Intervalo de recorrência inválido, usando padrão 1');
        cleaned.recurrenceInterval = 1;
      }
      
      // Validar recurrenceType
      const validTypes = ['daily', 'weekly', 'monthly', 'yearly'];
      if (!cleaned.recurrenceType || !validTypes.includes(cleaned.recurrenceType)) {
        console.warn('Tipo de recorrência inválido, usando padrão daily');
        cleaned.recurrenceType = 'daily';
      }
      
      // Se recorrenceCount está vazio mas não é null, definir como null
      if (cleaned.recurrenceCount === '' || cleaned.recurrenceCount === 'undefined') {
        cleaned.recurrenceCount = null;
      }
      
      console.log('Dados de recorrência validados:', {
        isRecurring: cleaned.isRecurring,
        recurrenceType: cleaned.recurrenceType,
        recurrenceInterval: cleaned.recurrenceInterval,
        recurrenceEndDate: cleaned.recurrenceEndDate,
        recurrenceCount: cleaned.recurrenceCount
      });
    }
    
    return cleaned;
  };

  // Função auxiliar para verificar se a tarefa existe no banco
  const verifyTaskExists = async (taskId) => {
    try {
      console.log('Verificando existência da tarefa:', taskId);
      const response = await taskService.getById(taskId);
      const exists = response && response.id === taskId;
      console.log('Tarefa existe:', exists);
      return exists;
    } catch (error) {
      console.error('Erro ao verificar tarefa:', error);
      return false;
    }
  };

  // Função auxiliar para processar componentes relacionados
  const processRelatedComponents = async (createdTask, taskData) => {
    const taskId = createdTask.id;
    
    // Processar subtarefas
    if (taskData.subtasks?.length > 0) {
      console.log(`=== DEBUG: Processando ${taskData.subtasks.length} subtarefas ===`);
      
      const subtaskPromises = taskData.subtasks
        .filter(subtask => subtask.title?.trim())
        .map(async (subtask, index) => {
          try {
            console.log(`Criando subtarefa "${subtask.title}"`);
            const { id, isNew, ...subtaskData } = subtask;
            
            // Usar função auxiliar para limpar datas inválidas
            const cleanedSubtaskData = cleanInvalidDates(subtaskData);
            
            await taskService.createSubtask(taskId, cleanedSubtaskData);
            console.log(`Subtarefa "${subtask.title}" criada com sucesso`);
          } catch (error) {
            console.error(`Erro ao criar subtarefa "${subtask.title}":`, error);
            toast.warning(`Erro ao criar subtarefa "${subtask.title}"`);
          }
        });
      
      await Promise.allSettled(subtaskPromises);
      console.log('Processamento de subtarefas concluído');
    }

    // Processar comentários
    if (taskData.comments?.length > 0) {
      console.log(`=== DEBUG: Processando ${taskData.comments.length} comentários ===`);
      
      const commentPromises = taskData.comments
        .filter(comment => comment.content?.trim())
        .map(async (comment, index) => {
          try {
            console.log(`Criando comentário`);
            await taskService.createComment(taskId, comment.content.trim());
            console.log(`Comentário criado com sucesso`);
          } catch (error) {
            console.error(`Erro ao criar comentário:`, error);
            toast.warning(`Erro ao criar comentário`);
          }
        });
      
      await Promise.allSettled(commentPromises);
      console.log('Processamento de comentários concluído');
    }

    // Processar anexos
    if (taskData.attachments?.length > 0) {
      console.log(`=== DEBUG: Processando ${taskData.attachments.length} anexos ===`);
      
      const attachmentPromises = taskData.attachments
        .filter(attachment => attachment.file)
        .map(async (attachment, index) => {
          try {
            console.log(`Fazendo upload do anexo "${attachment.originalName || attachment.file.name}"`);
            await taskService.uploadAttachment(taskId, attachment.file);
            console.log(`Anexo "${attachment.originalName || attachment.file.name}" enviado com sucesso`);
          } catch (error) {
            console.error(`Erro ao fazer upload do anexo "${attachment.originalName}":`, error);
            toast.warning(`Erro ao fazer upload do arquivo "${attachment.originalName || attachment.file.name}"`);
          }
        });
      
      await Promise.allSettled(attachmentPromises);
      console.log('Processamento de anexos concluído');
    }
  };

  const handleSaveTaskFromModal = async (taskData) => {
    console.log('=== DEBUG: Dados recebidos para salvamento ===');
    console.log('taskData:', taskData);
    console.log('subtasks:', taskData.subtasks);
    console.log('comments:', taskData.comments);
    console.log('attachments:', taskData.attachments);
    
    try {
      const finalTaskData = {
        ...taskData,
        userId: user.id,
        companyId: user.companyId,
        // Tratar data vazia ou inválida
        dueDate: taskData.dueDate && taskData.dueDate !== '' ? taskData.dueDate : null
      };

      // Remover os arrays extras do finalTaskData pois serão processados separadamente
      const { subtasks, comments, attachments, ...taskMainData } = finalTaskData;
      
      // Limpar datas inválidas usando função auxiliar
      const cleanedTaskData = cleanInvalidDates(taskMainData);
      
      // Se não é recorrente, limpar todos os campos de recorrência
      if (!cleanedTaskData.isRecurring) {
        cleanedTaskData.recurrenceType = null;
        cleanedTaskData.recurrenceInterval = null;
        cleanedTaskData.recurrenceEndDate = null;
        cleanedTaskData.recurrenceCount = null;
      }
      
      // Se lembrete não está habilitado, limpar reminderDate
      if (!cleanedTaskData.reminderEnabled) {
        cleanedTaskData.reminderDate = null;
      }
      
      console.log('=== DEBUG: Dados principais da tarefa (após limpeza) ===');
      console.log('taskMainData original:', taskMainData);
      console.log('taskMainData limpo:', cleanedTaskData);

      if (editingTaskData) {
        // Atualizar tarefa existente
        console.log('=== DEBUG: Atualizando tarefa existente ===');
        await taskService.update(editingTaskData.id, cleanedTaskData);
        toast.success('Tarefa atualizada com sucesso!');
        
        // Para edição de tarefa existente, vamos apenas adicionar novos itens
        // Isso evita problemas com endpoints de atualização que podem não existir
        
        // Processar apenas NOVAS subtarefas (sem ID ou com ID temporário)
        if (taskData.subtasks?.length > 0) {
          console.log('=== DEBUG: Processando novas subtarefas ===');
          
          try {
            const existingSubtasks = await taskService.getSubtasks(editingTaskData.id).catch(() => ({ subtasks: [] }));
            const existingIds = existingSubtasks.subtasks?.map(s => s.id) || [];
            console.log('Subtarefas existentes:', existingIds);
            
            for (const subtask of taskData.subtasks) {
              console.log('Processando subtarefa:', subtask);
              
              // Validar título da subtarefa
              if (!subtask.title || !subtask.title.trim()) {
                console.log('Subtarefa sem título, pulando:', subtask);
                continue;
              }
              
              // Só criar se for nova (flag isNew ou ID temporário)
              if (subtask.isNew || typeof subtask.id === 'string' || !existingIds.includes(subtask.id)) {
                console.log('Criando nova subtarefa:', subtask);
                try {
                  const { id, isNew, ...subtaskData } = subtask; // Remove ID temporário e flag
                  
                  // Usar função auxiliar para limpar datas inválidas
                  const cleanedSubtaskData = cleanInvalidDates(subtaskData);
                  
                  await taskService.createSubtask(editingTaskData.id, cleanedSubtaskData);
                  console.log('Subtarefa criada com sucesso');
                } catch (subtaskError) {
                  console.error('Erro específico ao criar subtarefa:', subtaskError);
                  toast.warning(`Erro ao salvar subtarefa: ${subtaskError.message}`);
                }
              } else {
                console.log('Subtarefa já existe, pulando:', subtask.id);
              }
            }
          } catch (error) {
            console.error('Erro ao processar subtarefas:', error);
            toast.warning('Erro ao processar subtarefas');
          }
        }
        
        // Processar apenas NOVOS comentários
        if (taskData.comments?.length > 0) {
          console.log('=== DEBUG: Processando novos comentários ===');
          
          try {
            const existingComments = await taskService.getComments(editingTaskData.id).catch(() => ({ comments: [] }));
            const existingIds = existingComments.comments?.map(c => c.id) || [];
            console.log('Comentários existentes:', existingIds);
            
            for (const comment of taskData.comments) {
              console.log('Processando comentário:', comment);
              
              // Validar conteúdo do comentário
              if (!comment.content || !comment.content.trim()) {
                console.log('Comentário sem conteúdo, pulando:', comment);
                continue;
              }
              
              // Só criar se for novo (flag isNew ou ID temporário)
              if (comment.isNew || typeof comment.id === 'string' || !existingIds.includes(comment.id)) {
                console.log('Criando novo comentário:', comment.content);
                try {
                  await taskService.createComment(editingTaskData.id, comment.content.trim());
                  console.log('Comentário criado com sucesso');
                } catch (commentError) {
                  console.error('Erro específico ao criar comentário:', commentError);
                  // Não parar o processo inteiro por causa de um comentário
                  toast.warning(`Erro ao salvar comentário: ${commentError.message}`);
                }
              } else {
                console.log('Comentário já existe, pulando:', comment.id);
              }
            }
          } catch (error) {
            console.error('Erro ao processar comentários:', error);
            toast.warning('Erro ao processar comentários');
            // Não parar o processo inteiro
          }
        }
        
        // Processar apenas NOVOS anexos
        if (taskData.attachments?.length > 0) {
          console.log('=== DEBUG: Processando novos anexos ===');
          
          try {
            for (const attachment of taskData.attachments) {
              console.log('Processando anexo:', attachment);
              
              // Só fazer upload se for novo e tiver arquivo
              if ((attachment.isNew || typeof attachment.id === 'string') && attachment.file) {
                console.log('Fazendo upload de novo anexo:', attachment.originalName);
                try {
                  // Enviar apenas o arquivo - o taskService criará o FormData
                  await taskService.uploadAttachment(editingTaskData.id, attachment.file);
                  console.log('Anexo enviado com sucesso');
                } catch (attachmentError) {
                  console.error('Erro específico ao fazer upload do anexo:', attachmentError);
                  toast.warning(`Erro ao fazer upload do arquivo "${attachment.originalName}": ${attachmentError.message}`);
                }
              } else {
                console.log('Anexo já existe ou sem arquivo, pulando:', attachment);
              }
            }
          } catch (error) {
            console.error('Erro ao processar anexos:', error);
            toast.warning('Erro ao processar anexos');
          }
        }
        
      } else {
        // Criar nova tarefa
        console.log('=== DEBUG: Criando nova tarefa ===');
        let createdTask;
        
        try {
          if (taskData.isRecurring) {
            console.log('=== DEBUG: Criando tarefa RECORRENTE ===');
            console.log('Dados para recorrência:', cleanedTaskData);
            createdTask = await taskRecurrenceService.createRecurrentTask(cleanedTaskData);
            console.log('Tarefa recorrente criada:', createdTask);
          } else {
            console.log('=== DEBUG: Criando tarefa NORMAL ===');
            console.log('Dados para tarefa normal:', cleanedTaskData);
            createdTask = await taskService.create(cleanedTaskData);
            console.log('Tarefa normal criada:', createdTask);
          }
        } catch (createError) {
          console.error('=== ERRO AO CRIAR TAREFA ===');
          console.error('Tipo:', taskData.isRecurring ? 'RECORRENTE' : 'NORMAL');
          console.error('Dados enviados:', cleanedTaskData);
          console.error('Erro detalhado:', createError);
          console.error('Response error:', createError.response?.data);
          throw createError; // Re-throw para ser capturado pelo catch principal
        }
        
        // AGUARDAR um breve delay para garantir que a tarefa foi persistida
        await new Promise(resolve => setTimeout(resolve, 150));
        
        // Verificar se a tarefa foi realmente criada
        if (!createdTask?.id) {
          console.error('=== ERRO: Tarefa sem ID ===');
          console.error('Resposta completa:', createdTask);
          console.error('Tipo de tarefa:', taskData.isRecurring ? 'RECORRENTE' : 'NORMAL');
          throw new Error(`Falha ao criar a tarefa ${taskData.isRecurring ? 'recorrente' : ''} - ID não retornado`);
        }
        
        console.log('Tarefa criada com sucesso, ID:', createdTask.id);
        console.log('Tipo:', taskData.isRecurring ? 'RECORRENTE' : 'NORMAL');
        
        // Verificar se a tarefa existe no banco antes de prosseguir
        const taskExists = await verifyTaskExists(createdTask.id);
        if (!taskExists) {
          throw new Error('Tarefa não foi persistida corretamente no banco de dados');
        }
        
        console.log('Tarefa verificada no banco, prosseguindo com componentes...');
        
        // Processar componentes relacionados com tratamento individual de erros
        await processRelatedComponents(createdTask, taskData);
        
        toast.success(taskData.isRecurring ? 'Tarefa recorrente criada com sucesso!' : 'Tarefa criada com sucesso!');
      }

      console.log('=== DEBUG: Salvamento concluído, recarregando tarefas ===');
      // Recarregar tarefas
      await loadTasks();
      
      // Fechar modal
      handleCloseFormModal();
      
    } catch (error) {
      console.error('=== DEBUG: Erro crítico ao salvar tarefa ===', error);
      
      // Verificar se é erro específico de sequenciamento
      if (error.message && error.message.includes('não foi persistida')) {
        toast.error('Erro de sincronização. Tente novamente em alguns segundos.');
      } else if (error.message && error.message.includes('recorrente')) {
        toast.error('Erro ao criar tarefa recorrente. Verifique as configurações de recorrência.');
      } else if (error.message && error.message.includes('Request failed with status code')) {
        const statusCode = error.message.match(/status code (\d+)/)?.[1];
        if (statusCode === '500') {
          toast.error('Erro interno do servidor. Verifique se o backend está funcionando corretamente.');
        } else if (statusCode === '404') {
          toast.error('Endpoint não encontrado. Verifique se as rotas do backend estão configuradas.');
        } else if (statusCode === '400') {
          toast.error('Dados inválidos para tarefa recorrente. Verifique os campos de recorrência.');
        } else {
          toast.error(`Erro do servidor (${statusCode}). Tente novamente.`);
        }
      } else if (error.message && error.message.includes('Falha ao criar a tarefa')) {
        toast.error('Erro ao criar tarefa. Verifique os dados e tente novamente.');
      } else {
        toast.error('Erro ao salvar tarefa: ' + (error.message || 'Erro desconhecido'));
      }
      
      // Não fazer throw para não quebrar completamente a interface
      console.log('=== DEBUG: Continuando execução apesar do erro ===');
    }
  };

  return (
    <div className={classes.root}>
      {/* Título Principal */}
      <Typography variant="h4" component="h1" className={classes.mobileTitle}>
        📋 Gerenciador de Tarefas
      </Typography>

      {/* Layout Responsivo */}
      <div className={classes.mobileContainer}>
        
        {/* Sidebar - Controles */}
        <div className={classes.sidebar}>
          
          {/* Botão Nova Tarefa */}
          <Paper className={classes.mobilePaper}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              startIcon={<AddIcon />}
              onClick={() => handleOpenFormModal()}
              fullWidth
              className={classes.mobileButton}
              style={{ marginBottom: '1rem' }}
            >
              Nova Tarefa
            </Button>
            
            {/* Botões de Ação */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Button
                variant="contained"
                startIcon={<DashboardIcon />}
                onClick={() => history.push('/task-dashboard')}
                fullWidth
                className={`${classes.navigationButton} ${classes.dashboardButton}`}
              >
              Dashboard
              </Button>
              
              <Button
                variant="contained"
                startIcon={<ArchiveIcon />}
                onClick={() => history.push('/task-archive')}
                fullWidth
                className={`${classes.navigationButton} ${classes.archiveButton}`}
              >
              Arquivadas
              </Button>
            </div>
          </Paper>

          {/* Exportação */}
          <Paper className={classes.mobilePaper}>
            <Typography variant="h6" color="primary" gutterBottom>
              📄 Exportação
            </Typography>
            
            <div className={classes.mobileButtonGroup}>
              <Button
                variant="outlined"
                startIcon={<PictureAsPdfIcon />}
                onClick={handleExportPDF}
                disabled={loading}
                style={{ flex: 1 }}
              >
                PDF
              </Button>
              <Button
                variant="outlined"
                startIcon={<TableChartIcon />}
                onClick={handleExportExcel}
                disabled={loading}
                style={{ flex: 1 }}
              >
                Excel
              </Button>
            </div>
          </Paper>

          {/* Filtros */}
          <Paper className={classes.mobilePaper}>
            <Typography variant="h6" gutterBottom>
              🔍 Filtros
            </Typography>
            
            <TextField
              label="Buscar tarefas..."
              value={filters.searchParam}
              onChange={(e) => handleFilterChange('searchParam', e.target.value)}
              variant="outlined"
              size="small"
              fullWidth
              style={{ marginBottom: '1rem' }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: filters.searchParam && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => handleFilterChange('searchParam', '')}>
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            
            <div className={classes.mobileButtonGroup} style={{ marginBottom: '1rem' }}>
              <Button
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={() => setShowFilters(!showFilters)}
                size="small"
                style={{ flex: 1 }}
              >
                Filtros {getActiveFiltersCount() > 0 && `(${getActiveFiltersCount()})`}
              </Button>

              <Button
                variant="outlined"
                startIcon={<WarningIcon />}
                onClick={() => setQuickFilterDialog(true)}
                size="small"
                color="primary"
                style={{ flex: 1 }}
              >
                Avançados
              </Button>
            </div>
            
            {/* Botão Limpar Filtros sempre visível */}
            <Button
              variant="text"
              startIcon={<ClearIcon />}
              onClick={() => {
                clearFilters();
                setAdvancedFilters({
                  hasComments: false,
                  hasAttachments: false,
                  hasSubtasks: false,
                  overdueOnly: false,
                  todayOnly: false,
                  tomorrowOnly: false,
                  privateOnly: false,
                  publicOnly: false
                });
              }}
              size="small"
              color="secondary"
              fullWidth
              style={{ marginBottom: '1rem' }}
              disabled={getActiveFiltersCount() === 0 && !Object.values(advancedFilters).some(Boolean)}
            >
              🧹 Limpar Todos os Filtros
            </Button>
            
            <Collapse in={showFilters}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <FormControl variant="outlined" size="small" fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={filters.status}
                    onChange={(e) => handleFilterChange('status', e.target.value)}
                    label="Status"
                  >
                    <MenuItem value="">Todos</MenuItem>
                    <MenuItem value="pending">Pendente</MenuItem>
                    <MenuItem value="completed">Concluída</MenuItem>
                  </Select>
                </FormControl>
                
                <FormControl variant="outlined" size="small" fullWidth>
                  <InputLabel>Prioridade</InputLabel>
                  <Select
                    value={filters.priority}
                    onChange={(e) => handleFilterChange('priority', e.target.value)}
                    label="Prioridade"
                  >
                    <MenuItem value="">Todas</MenuItem>
                    <MenuItem value="low">Baixa</MenuItem>
                    <MenuItem value="medium">Média</MenuItem>
                    <MenuItem value="high">Alta</MenuItem>
                  </Select>
                </FormControl>

                {/* Toggle Atribuídas a mim */}
                <FormControlLabel
                  control={<Checkbox color="primary" checked={!!filters.onlyAssigned} onChange={(e) => handleFilterChange('onlyAssigned', e.target.checked)} />}
                  label="Atribuídas a mim"
                />
              </div>
            </Collapse>
            
            {/* Chips de filtros ativos removidos para evitar conflitos de JSX */}
          </Paper>
        </div>

        {/* Conteúdo Principal - Lista de Tarefas */}
        <div className={classes.mainContent}>
          <Paper className={classes.listContainer}>
        <Typography variant="h6" style={{ padding: '1rem' }}>
          Todas Tarefas ({totalTasks})
        </Typography>
        
        {loading ? (
          <Typography style={{ padding: '1rem', textAlign: 'center' }}>
            Carregando...
          </Typography>
        ) : tasks.length === 0 ? (
          <Typography style={{ padding: '1rem', textAlign: 'center' }}>
            Nenhuma tarefa encontrada
          </Typography>
        ) : (
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="tasks">
              {(provided) => {
                const { privateTasks, publicTasks, totalPrivate, totalPublic } = getSeparatedTasks();
                
                return (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    {/* Seção de Tarefas Privadas */}
                    {renderTaskSection(privateTasks, "Tarefas Privadas", false, 0)}
                    
                    {/* Seção de Tarefas Públicas */}
                    {renderTaskSection(publicTasks, "Tarefas Públicas", true, totalPrivate)}
                    
                    {privateTasks.length === 0 && publicTasks.length === 0 && (
                      <Typography style={{ padding: '1rem', textAlign: 'center' }}>
                        Nenhuma tarefa encontrada com os filtros aplicados
                      </Typography>
                    )}
                    
                    {provided.placeholder}
                  </div>
                );
              }}
            </Droppable>
          </DragDropContext>
        )}

        {selectedTaskIds.length > 0 && (
          <Box className={classes.bulkActionsBar}>
            <Typography variant="body2" style={{ fontWeight: 600 }}>
              {selectedTaskIds.length} tarefa(s) selecionadas
            </Typography>
            <Box className={classes.bulkActionsGroup}>
              <Button variant="outlined" size="small" onClick={selectAllVisibleTasks} disabled={loading}>
                Selecionar visíveis
              </Button>
              <Button variant="outlined" size="small" onClick={clearTaskSelection} disabled={loading}>
                Limpar seleção
              </Button>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                onClick={handleBulkDeleteRequest}
                startIcon={<DeleteSweepIcon />}
                disabled={loading}
              >
                Excluir selecionadas
              </Button>
            </Box>
          </Box>
        )}
      </Paper>

      {/* Modal de Filtros Avançados */}
      <Dialog 
        open={quickFilterDialog} 
        onClose={() => setQuickFilterDialog(false)} 
        maxWidth="sm" 
        fullWidth
        PaperProps={{
          style: {
            margin: '16px',
            width: 'calc(100% - 32px)',
            maxHeight: 'calc(100% - 32px)'
          }
        }}
      >
        <DialogTitle>Filtros Avançados</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                💬 Filtrar por conteúdo:
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={advancedFilters.hasComments}
                    onChange={(e) => setAdvancedFilters(prev => ({ ...prev, hasComments: e.target.checked }))}
                  />
                }
                label="Apenas tarefas com comentários"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={advancedFilters.hasAttachments}
                    onChange={(e) => setAdvancedFilters(prev => ({ ...prev, hasAttachments: e.target.checked }))}
                  />
                }
                label="Apenas tarefas com anexos"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={advancedFilters.hasSubtasks}
                    onChange={(e) => setAdvancedFilters(prev => ({ ...prev, hasSubtasks: e.target.checked }))}
                  />
                }
                label="Apenas tarefas com subtarefas"
              />
            </Grid>
            
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                ⏰ Filtrar por vencimento:
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={advancedFilters.overdueOnly}
                    onChange={(e) => setAdvancedFilters(prev => ({ ...prev, overdueOnly: e.target.checked }))}
                  />
                }
                label="Apenas tarefas atrasadas"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={advancedFilters.todayOnly}
                    onChange={(e) => setAdvancedFilters(prev => ({ ...prev, todayOnly: e.target.checked }))}
                  />
                }
                label="Apenas tarefas de hoje"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={advancedFilters.tomorrowOnly}
                    onChange={(e) => setAdvancedFilters(prev => ({ ...prev, tomorrowOnly: e.target.checked }))}
                  />
                }
                label="Apenas tarefas de amanhã"
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                🔐 Filtrar por visibilidade:
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={advancedFilters.privateOnly}
                    onChange={(e) => setAdvancedFilters(prev => ({ ...prev, privateOnly: e.target.checked }))}
                  />
                }
                label="Apenas tarefas privadas"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={advancedFilters.publicOnly}
                    onChange={(e) => setAdvancedFilters(prev => ({ ...prev, publicOnly: e.target.checked }))}
                  />
                }
                label="Apenas tarefas públicas"
              />
            </Grid>

          </Grid>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              setAdvancedFilters({
                hasComments: false,
                hasAttachments: false,
                hasSubtasks: false,
                overdueOnly: false,
                todayOnly: false,
                tomorrowOnly: false,
                privateOnly: false,
                publicOnly: false
              });
            }}
          >
            Limpar Filtros
          </Button>
          <Button onClick={() => setQuickFilterDialog(false)} color="primary">
            Aplicar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Formulário (Criação/Edição) */}
      <TaskFormModal
        open={formModalOpen}
        onClose={handleCloseFormModal}
        onSave={handleSaveTaskFromModal}
        task={editingTaskData}
      />

      {/* Modal de Confirmação para Exclusão Simples */}
      <Dialog
        open={deleteConfirmModal.open}
        onClose={handleCancelDelete}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)'
          }
        }}
      >
        <DialogTitle style={{
          background: 'linear-gradient(135deg, #ff6b6b, #ee5a24)',
          color: 'white',
          padding: '20px 24px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <DeleteIcon style={{ fontSize: '1.5rem' }} />
          <div>
            <Typography variant="h6" style={{ fontWeight: 600, margin: 0 }}>
              ⚠️ Confirmar Exclusão
            </Typography>
            <Typography variant="caption" style={{ opacity: 0.9, display: 'block', marginTop: '4px' }}>
              Esta ação não pode ser desfeita
            </Typography>
          </div>
        </DialogTitle>
        
        <DialogContent style={{ padding: '24px' }}>
          <Box style={{
            background: 'linear-gradient(135deg, #ffebee, #fce4ec)',
            padding: '16px',
            borderRadius: '12px',
            border: '1px solid #ffcdd2',
            marginBottom: '16px'
          }}>
            <Typography variant="h6" style={{ 
              color: '#d32f2f', 
              fontWeight: 600,
              marginBottom: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              🗑️ Tem certeza que deseja excluir esta tarefa?
            </Typography>
            <Typography variant="body1" style={{ 
              color: '#666',
              fontWeight: 500,
              background: 'rgba(255,255,255,0.7)',
              padding: '8px 12px',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              marginTop: '12px'
            }}>
              📋 "{deleteConfirmModal.taskTitle}"
            </Typography>
          </Box>
          
          <Typography variant="body2" style={{ 
            color: '#666', 
            fontStyle: 'italic',
            textAlign: 'center',
            background: '#f5f5f5',
            padding: '12px',
            borderRadius: '8px'
          }}>
            💡 Esta ação irá remover permanentemente a tarefa e todos os seus dados associados (subtarefas, comentários, anexos).
          </Typography>
        </DialogContent>
        
        <DialogActions style={{ 
          padding: '16px 24px 24px',
          gap: '12px',
          justifyContent: 'center'
        }}>
          <Button 
            onClick={handleCancelDelete}
            variant="outlined"
            style={{
              borderRadius: '25px',
              padding: '10px 24px',
              borderColor: '#666',
              color: '#666',
              fontWeight: 600,
              textTransform: 'none'
            }}
          >
            ✖️ Cancelar
          </Button>
          <Button 
            onClick={handleConfirmDelete}
            variant="contained"
            disabled={loading}
            style={{
              borderRadius: '25px',
              padding: '10px 24px',
              background: 'linear-gradient(45deg, #ff6b6b, #ee5a24)',
              color: 'white',
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: '0 4px 15px rgba(244, 67, 54, 0.4)'
            }}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
          >
            {loading ? '🔄 Excluindo...' : '🗑️ Confirmar Exclusão'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Confirmação para Exclusão com Recorrência */}
      <RecurrenceDeleteModal
        open={recurrenceDeleteModal.open}
        onClose={handleCloseRecurrenceModal}
        onConfirm={handleConfirmRecurrenceDelete}
        taskTitle={recurrenceDeleteModal.taskTitle}
        recurrenceInfo={recurrenceDeleteModal.recurrenceInfo}
        allowStopRecurrence={recurrenceDeleteModal.allowStopRecurrence}
        allowDeleteFuture={recurrenceDeleteModal.allowDeleteFuture}
        initialStopRecurrence={recurrenceDeleteModal.initialStopRecurrence}
        initialDeleteFuture={recurrenceDeleteModal.initialDeleteFuture}
      />

      <Dialog
        open={bulkDeleteModal.open}
        onClose={handleCloseBulkDeleteModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Excluir tarefas selecionadas</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1" gutterBottom>
            Você selecionou <strong>{bulkDeleteModal.total}</strong> tarefa(s).
          </Typography>

          <Box
            style={{
              padding: '12px',
              borderRadius: '8px',
              marginBottom: '16px',
              backgroundColor: bulkDeleteModal.recurringCount > 0 ? '#fff3e0' : '#e3f2fd',
              border: '1px solid rgba(0,0,0,0.08)'
            }}
          >
            <Typography variant="body2" style={{ fontWeight: 500 }}>
              {bulkDeleteModal.recurringCount > 0
                ? `${bulkDeleteModal.recurringCount} tarefa(s) possuem recorrência ativa.`
                : 'Nenhuma das tarefas selecionadas possui recorrência ativa.'}
            </Typography>
          </Box>

          {bulkDeleteModal.recurringCount > 0 && (
            <Box style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={bulkDeleteModal.includeStopRecurrence}
                    onChange={(e) =>
                      setBulkDeleteModal((prev) => ({
                        ...prev,
                        includeStopRecurrence: e.target.checked,
                        includeDeleteFuture: e.target.checked ? prev.includeDeleteFuture : false
                      }))
                    }
                  />
                }
                label="Parar recorrências das tarefas selecionadas"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    color="secondary"
                    checked={bulkDeleteModal.includeDeleteFuture}
                    disabled={!bulkDeleteModal.includeStopRecurrence}
                    onChange={(e) =>
                      setBulkDeleteModal((prev) => ({
                        ...prev,
                        includeDeleteFuture: e.target.checked
                      }))
                    }
                  />
                }
                label="Excluir futuras ocorrências pendentes"
              />
            </Box>
          )}

          <Typography variant="body2" color="error" style={{ marginTop: '16px' }}>
            Esta ação não pode ser desfeita.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBulkDeleteModal} disabled={loading}>
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmBulkDelete}
            color="secondary"
            variant="contained"
            startIcon={<DeleteSweepIcon />}
            disabled={loading}
          >
            Confirmar exclusão
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Confirmação para Arquivamento */}
      <Dialog
        open={archiveConfirmModal.open}
        onClose={handleCancelArchive}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)'
          }
        }}
      >
        <DialogTitle style={{
          background: 'linear-gradient(135deg, #ffc107, #ff9800)',
          color: 'white',
          padding: '20px 24px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <ArchiveIcon style={{ fontSize: '1.5rem' }} />
          <div>
            <Typography variant="h6" style={{ fontWeight: 600, margin: 0 }}>
              {archiveConfirmModal.isCurrentlyArchived ? '📤 Desarquivar Tarefa' : '📦 Arquivar Tarefa'}
            </Typography>
            <Typography variant="caption" style={{ opacity: 0.9, display: 'block', marginTop: '4px' }}>
              {archiveConfirmModal.isCurrentlyArchived ? 'A tarefa voltará à lista ativa' : 'A tarefa será movida para arquivo'}
            </Typography>
          </div>
        </DialogTitle>
        
        <DialogContent style={{ padding: '24px' }}>
          <Box style={{
            background: 'linear-gradient(135deg, #fff8e1, #fffde7)',
            padding: '16px',
            borderRadius: '12px',
            border: '1px solid #ffcc02',
            marginBottom: '16px'
          }}>
            <Typography variant="h6" style={{ 
              color: '#f57c00', 
              fontWeight: 600,
              marginBottom: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              {archiveConfirmModal.isCurrentlyArchived ? '📤 Tem certeza que deseja desarquivar?' : '📦 Tem certeza que deseja arquivar?'}
            </Typography>
            <Typography variant="body1" style={{ 
              color: '#666',
              fontWeight: 500,
              background: 'rgba(255,255,255,0.7)',
              padding: '8px 12px',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              marginTop: '12px'
            }}>
              📋 "{archiveConfirmModal.taskTitle}"
            </Typography>
          </Box>
          
          <Typography variant="body2" style={{ 
            color: '#666', 
            fontStyle: 'italic',
            textAlign: 'center',
            background: '#f5f5f5',
            padding: '12px',
            borderRadius: '8px'
          }}>
            {archiveConfirmModal.isCurrentlyArchived 
              ? '💡 A tarefa voltará a aparecer na lista principal de tarefas ativas.'
              : '💡 A tarefa será removida da lista principal e ficará disponível apenas no arquivo.'
            }
          </Typography>
        </DialogContent>
        
        <DialogActions style={{ 
          padding: '16px 24px 24px',
          gap: '12px',
          justifyContent: 'center'
        }}>
          <Button 
            onClick={handleCancelArchive}
            variant="outlined"
            style={{
              borderRadius: '25px',
              padding: '10px 24px',
              borderColor: '#666',
              color: '#666',
              fontWeight: 600,
              textTransform: 'none'
            }}
          >
            ✖️ Cancelar
          </Button>
          <Button 
            onClick={handleConfirmArchive}
            variant="contained"
            disabled={loading}
            style={{
              borderRadius: '25px',
              padding: '10px 24px',
              background: 'linear-gradient(45deg, #ffc107, #ff9800)',
              color: 'white',
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: '0 4px 15px rgba(255, 193, 7, 0.4)'
            }}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <ArchiveIcon />}
          >
            {loading 
              ? '🔄 Processando...' 
              : archiveConfirmModal.isCurrentlyArchived 
                ? '📤 Confirmar Desarquivamento' 
                : '📦 Confirmar Arquivamento'
            }
          </Button>
        </DialogActions>
      </Dialog>
        </div>
      </div>
    </div>
  );
};


export default ToDoList;
